<template>
    <div class="modal modal-video fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="modal-inner">
                    <div class="video-slider">
                        <div class="item">
                            <div class="video-item">
                                <iframe :src="video" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'VideoModal',
    props: {
        modalId: String,
        video: String
    }
}

</script>



<style scoped>

</style>
